import { Option } from "@/components/select/AsyncAutocompleteSelect";
import { GetCashRequestsProps } from "@/services/cash-requests.service";
import dayjs, { Dayjs } from "dayjs";
import { formatCurrencyInputToNumber } from "@/utils/query-string";

export interface CRFRProps {
  request_date?: Dayjs;
  sucursal: string[];
  request_amount: string;
  requester: string;
  balance_control: string[];
  account_number: Option;
  estados?: number[];
}

export const getCashRequestFilter = (
  event: CRFRProps,
): Partial<GetCashRequestsProps> => {
  let amount: string | undefined;

  const estados = Array.isArray(event?.estados)
    ? (event.estados as unknown[]).reduce<number[]>((acc, item) => {
        if (Array.isArray(item)) {
          return acc.concat(item as number[]);
        }
        if (typeof item === "string") {
          const parsed = item
            .split("|")
            .map(Number)
            .filter((n) => Number.isFinite(n));
          return acc.concat(parsed);
        }
        if (typeof item === "number") {
          acc.push(item);
        }
        return acc;
      }, [])
    : [];

  if (event?.request_amount) {
    const num = formatCurrencyInputToNumber(event.request_amount);

    if (!Number.isNaN(num)) {
      amount = num.toFixed(2);
    }
  }

  return {
    ...(estados?.length
      ? {
          estados,
        }
      : {}),
    ...(event?.request_date && dayjs(event?.request_date).isValid()
      ? {
          fechaDesde: dayjs(event?.request_date).toISOString(),
        }
      : {}),
    ...(event?.account_number?.value
      ? {
          NroCuenta: event.account_number.value,
        }
      : {}),
    ...(event?.balance_control?.length
      ? {
          Control: event?.balance_control?.[0],
        }
      : {}),
    ...(event?.sucursal?.length
      ? {
          ClaveSucursal: event?.sucursal,
        }
      : {}),
    ...(event?.request_amount && amount
      ? {
          monto: amount,
        }
      : {}),
    ...(event?.requester
      ? {
          Solicitante: event?.requester,
        }
      : {}),
  };
};
